import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { ArrowRight } from 'lucide-react'
import { useState } from 'react'

export const CTASection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [emailValue, setEmailValue] = useState('')
  const [messageValue, setMessageValue] = useState('')
  const [emailError, setEmailError] = useState('')
  return (
    <section className='relative z-20 bg-[#9687F5] py-20'>
      <div className='container mx-auto px-8'>
        {/* Large headline - full width */}
        <h1 className='text-6xl md:text-8xl lg:text-[10rem] font-medium text-black leading-none mb-8'>
          Ready to connect?
        </h1>

        {/* Location and copyright - small row */}
        <div className='flex justify-between items-center text-sm font-medium text-black mb-8'>
          <span>©2025</span>
          <span>TULSA, OK</span>
        </div>

        {/* Border line */}
        <div className='border-t border-black mb-8'></div>

        {/* 3 column layout */}
        <div className='grid grid-cols-1 md:grid-cols-3 gap-8 items-end'>
          {/* Column 1 - Statement */}
          <div>
            <p className='text-xs font-semibold tracking-wider text-black mb-4'>
              START JOURNEY
            </p>
          </div>

          {/* Column 2 - Description */}
          <div>
            <p className='text-lg text-black leading-relaxed'>
              Join the leading fuel companies already connected on Crossroads.
              From terminal operators to C-store chains, our network creates
              value at every link in the supply chain.
            </p>
          </div>

          {/* Column 3 - CTA Button */}
          <div className='flex justify-start md:justify-end'>
            <Button
              size='lg'
              className='bg-black text-white hover:bg-black/90 text-base px-6 py-3 font-medium group'
              onClick={() => setIsModalOpen(true)}
            >
              Book A Meeting
              <ArrowRight className='ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform' />
            </Button>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <>
          <div
            className='fixed inset-0 z-40 bg-black/40 backdrop-blur-sm'
            onClick={() => setIsModalOpen(false)}
          />
          <div className='fixed inset-0 z-50 flex items-center justify-center px-4'>
            <div className='w-full max-w-md rounded-2xl border border-black/10 bg-white p-6 shadow-2xl'>
              <h3 className='text-lg font-semibold text-gray-900 mb-3'>
                Request a Meeting
              </h3>
              <form
                onSubmit={(event) => {
                  event.preventDefault()
                  if (!emailValue.trim()) {
                    setEmailError('Email is required')
                    return
                  }
                  console.log(
                    'this will send an email to joel.davies@gravitate.energy',
                    {
                      email: emailValue.trim(),
                      comment: messageValue.trim() || undefined,
                    },
                  )
                  setIsModalOpen(false)
                  setEmailValue('')
                  setMessageValue('')
                  setEmailError('')
                }}
              >
                <div className='space-y-4'>
                  <div className='space-y-2'>
                    <label className='text-sm font-medium text-gray-700'>
                      Your Email
                    </label>
                    <Input
                      type='email'
                      value={emailValue}
                      onChange={(event) => {
                        setEmailValue(event.target.value)
                        if (emailError) {
                          setEmailError('')
                        }
                      }}
                      placeholder='you@example.com'
                      className='bg-[#221a43] text-white/80 placeholder:text-white/60 border-[#7C6EF0] focus-visible:ring-[#9687F5]'
                    />
                    {emailError && (
                      <p className='text-sm text-red-500'>{emailError}</p>
                    )}
                  </div>
                  <div className='space-y-2'>
                    <label className='text-sm font-medium text-gray-700'>
                      Comment
                    </label>
                    <textarea
                      value={messageValue}
                      onChange={(event) => setMessageValue(event.target.value)}
                      placeholder='Share context for the meeting'
                      className='w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 focus:border-gray-400 focus:outline-none focus:ring-0'
                      rows={4}
                    />
                  </div>
                  <div className='flex items-center justify-end gap-3'>
                    <Button
                      type='button'
                      variant='ghost'
                      className='text-gray-600 hover:bg-gray-100'
                      onClick={() => {
                        setIsModalOpen(false)
                        setEmailValue('')
                        setMessageValue('')
                        setEmailError('')
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type='submit'
                      className='bg-[#9687F5] text-white hover:bg-[#8073e8]'
                    >
                      Send Request
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </section>
  )
}
